export const DEMO_STATUSES = [
  ['new', 'New'], ['contacted', 'Contacted'], ['demo_scheduled', 'Demo scheduled'], ['demo_done', 'Demo done'],
  ['converted', 'Converted'], ['lost', 'Lost'], ['spam', 'Spam'],
];
export const DEPLOYMENTS = [['not_sure', 'Not sure yet'], ['cloud', 'Cloud'], ['on_premise', 'On-premise']];
export const statusLabel = (s) => (DEMO_STATUSES.find(([v]) => v === s) || [s, s])[1];
export const deploymentLabel = (d) => (DEPLOYMENTS.find(([v]) => v === d) || [d, d])[1];
const CLS = {
  new: 'badge-open', contacted: 'badge-in-progress', demo_scheduled: 'badge-medium', demo_done: 'badge-resolved',
  converted: 'badge-resolved', lost: 'badge-closed', spam: 'badge-critical',
};
export const statusClass = (s) => CLS[s] || '';
